<template>
  <v-navigation-drawer
    v-model="drawer"
    width="400"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }}</span>
    </div>

    <div class="pl-3 pt-3 pr-3" style="height: 80vh;">
      <template>
        <v-row>
          <v-col cols="12">
            <span>Categoria de Gastos</span>
            <v-text-field
              ref="name"
              outlined
              hide-details="auto"
              required
              disabled
              value="PLANILLA"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <span>Monto a Pagar</span>
            <v-text-field
              v-model="newItem"
              ref="name"
              outlined
              hide-details="auto"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <span>Pago desde</span>
            <v-select v-model="desde" :items="itemsDesde" outlined></v-select>
          </v-col>
        </v-row>
        <v-row v-if="desde == 'CAJA'">
          <v-col cols="12">
            <span>Sucursal</span>
            <v-autocomplete
              v-model="office_id"
              :items="offices"
              label="Seleccione sucursal"
              hide-details
              outlined
              item-text="name"
              item-value="id"
              clearable
              @change="handleSelectOffice"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row v-if="desde == 'CAJA'">
          <v-col cols="12">
            <span>Caja</span>
            <v-select
              v-model="till"
              :items="tills"
              item-text="name"
              item-value="id"
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-row v-if="desde == 'CUENTA BANCARIA'">
          <v-col cols="12">
            <span>Cuenta Bancaria</span>
            <v-select
              v-model="cuenta"
              :items="accounts"
              item-text="bank.name"
              item-value="id"
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-row>{{ selected_till }}</v-row>
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn block height="40" dark color="red" @click="handleCancel">
              <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
              Cerrar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn dark color="success" block height="40" @click="pagar">
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Pagar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";
import router from "@/router/index";

export default {
  name: "Pagar",
  data() {
    return {
      visible_pagar: false,
      cuenta: null,
      newItem: null,
      till: null,
      sede_id: null,
      office_id: null,
      till_seleted: null,
      itemsDesde: ["CAJA", "CUENTA BANCARIA"],
      desde: null,
      drawer: false,
      titleForm: null,
      action: null,
      pagoForm: {
        id: null,
        categoriagasto_id: null,
        monto: null,
        glosa: null,
        cuenta_id: null,
        pagadodesde: null,
        caja_id: null,
        till_operation_id: null,
        movement_id: null,
        acount_id: null,
        office_id: null,
      },
      descuentos: [],
      monto: null,
      auxDescuentos: [],
    };
  },
  computed: {
    ...mapState("authentication", ["till_user_id", "company_id"]),
    ...mapState("offices", ["offices"]),
    ...mapState("accounts", ["accounts"]),
    ...mapState("tills", ["tills", "selected_till"]),
  },
  methods: {
    ...mapActions("planillas", ["getPlanillas"]),
    ...mapActions("tills", [
      "getAvailable",
      "select_till",
      "getOperations",
      "empty_tills",
      "empty_operations",
      "empty_summary",
      "getLastClosed",
    ]),
    ...mapActions("planillaDetalle", ["actualizaEmpleado", "pagarPlanilla"]),
    async pagar() {
      this.pagoForm.id = parseInt(localStorage.getItem("id_planilla"));
      this.pagoForm.categoriagasto_id = 3;
      this.pagoForm.monto = this.newItem;
      this.pagoForm.glosa = "PAGO DE PLANILLA";
      this.pagoForm.cuenta_id = this.cuenta;
      this.pagoForm.pagadodesde = this.desde;
      this.pagoForm.caja_id = this.till;
      this.pagoForm.till_operation_id = null;
      this.pagoForm.movement_id = null;
      this.pagoForm.acount_id = this.cuenta;
      this.pagoForm.office_id = this.office_id;
      // console.log(this.pagoForm);
      this.pagarPlanilla(this.pagoForm);
      this.getPlanillas();
      this.closeForm();
      //router.push('/app/planillas/Planillas');
    },
    async showForm(title, total) {
      //this.auxDescuentos = item.descuento
      this.newItem = total;
      //console.log(item)
      this.titleForm = title;
      this.drawer = !this.drawer;
    },
    guardaDescuento() {
      this.descuentoForm.id = this.newItem.id;
      this.actualizaEmpleado(this.descuentoForm);
      // console.log(this.descuentoForm);
    },
    handleCancel() {
      this.closeForm();
    },
    closeForm() {
      this.clearData();
      this.drawer = false;
    },
    clearData() {
      this.titleForm = null;
      this.pagoForm.id = null;
      this.pagoForm.categoriagasto_id = null;
      this.pagoForm.monto = null;
      this.pagoForm.glosa = null;
      this.pagoForm.cuenta_id = null;
      this.pagoForm.pagadodesde = null;
      this.pagoForm.caja_id = null;
      this.pagoForm.till_operation_id = null;
      this.pagoForm.movement_id = null;
      this.pagoForm.acount_id = null;
      this.pagoForm.office_id = null;
    },
    async handleSelectOffice(value) {
      // console.log('valor :',value);
      this.office_id = value;
      this.select_till(null);
      if (value !== undefined && value !== null) {
        let filters = {
          office_id: this.office_id,
          till_id: this.till_user_id,
        };
        await this.getAvailable(filters);
      }
    },
    async loadTills() {
      if (this.till_user_id) {
        let filters = {
          till_id: this.till_user_id,
        };
        await this.getAvailable(filters);
      } else {
        await this.getAvailable();
      }
    },
  },
  created() {
    this.loadTills();
  },
};
</script>

<style scoped></style>
